import { render } from "./SoeDigitalTrend2026.vue?vue&type=template&id=60de3d3e&scoped=true"
import script from "./SoeDigitalTrend2026.vue?vue&type=script&lang=js"
export * from "./SoeDigitalTrend2026.vue?vue&type=script&lang=js"

import "./SoeDigitalTrend2026.vue?vue&type=style&index=0&id=60de3d3e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60de3d3e"]])

export default __exports__